import { get, post, postFormData } from '@/service/http';

const vipUrl = process.env.VUE_APP_VIP_URL;
const docBaseUrl = process.env.VUE_APP_DOCSERVICE_URL;
const audioBaseUrl = process.env.VUE_APP_VOICE_URL;
const syncUploadBaseUrl = process.env.VUE_APP_SYNCUPLOAD_URL;
const congifUrl = process.env.VUE_APP_CONFIG_URL;
const messageCenterBaseUrl = process.env.VUE_APP_MESSAGE_CENTER_URL;

const getVipStatus = (param) => post(`${vipUrl}/user/status`, param);

const getVipList = (param) => get(`${vipUrl}/plan/sviplist`, param);

const getPayOrder = (param) => postFormData(`${vipUrl}/pay/order`, param);

const getQrcode = (param) => postFormData(`${vipUrl}/pay/qrcode`, param);

const getOrderStatus = (param) => postFormData(`${vipUrl}/pay/status`, param);

// 增量包会员套餐
const getPlans = (params) => get(`${vipUrl}/increase/plans`, params);

// 获取用户vip详情信息，例如文档翻译剩余字符数
const getDetailInfo = (param) => get(`${docBaseUrl}/doctrans/vip/getUserVipInfo`, param);

// 兑换会员码
const exchangeVipCode = (param) => postFormData(`${vipUrl}/pay/verifyCode`, param);

// 获取音频时长
const getAudioInfo = (signData, mysticTime) => get(`${audioBaseUrl}/login?sign=${signData}&mysticTime=${mysticTime}`);

// 获取同传用户信息
const getSyncInfo = (params) => get(`${syncUploadBaseUrl}/user/info`, params);

// 首页 banner
const getHomeBanner = () => get(`${congifUrl}//fanyiWebsiteHeaderMap`);

// 获取权益
const privilegeShow = (params) => get(`${vipUrl}/privilege/show`, params);

// 消息中心接口
const getMessageList = (params) => get(`${messageCenterBaseUrl}/message/official/list`, params);

const getMessageDetail = (params) => get(`${messageCenterBaseUrl}/message/official/pull`, params);

const pushMessage = (params) => postFormData(`${messageCenterBaseUrl}/message/push`, params);

const setMessageRead = (params) => postFormData(`${messageCenterBaseUrl}/message/official/markread`, params);

const getMessageUnread = (params) => get(`${messageCenterBaseUrl}/message/official/unread`, params);

// 福利接口
const getSingleSvipWelfare = (params) => get(`${vipUrl}/activity/svip/discount`, params);

const getWelfareList = () => get(`${vipUrl}/user/desk/welfare`);

export default {
  getVipStatus,
  getVipList,
  getPayOrder,
  getQrcode,
  getOrderStatus,
  getPlans,
  getDetailInfo,
  exchangeVipCode,
  getAudioInfo,
  getSyncInfo,
  getHomeBanner,
  privilegeShow,
  getMessageList,
  getMessageDetail,
  pushMessage,
  setMessageRead,
  getMessageUnread,
  getSingleSvipWelfare,
  getWelfareList,
};
